var map = {
	"./close.svg": "251a",
	"./f-bandcamp.svg": "465c",
	"./f-facebook.svg": "1250",
	"./f-instagram.svg": "1302",
	"./f-soundcloud.svg": "73ce",
	"./h-instagram.svg": "1204",
	"./h-linkedin.svg": "e5bf",
	"./h-vimeo.svg": "3756",
	"./pause.svg": "326e",
	"./play.svg": "27c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f297";